import routes from "../routes";
import store from "../store/index";
import { checkPermission } from "./checkPermission";
import history from "./history";

export const onLogout = () => {
  localStorage.removeItem("water_bill_access_token");
  localStorage.removeItem("water_bill_refresh_token");
  store.getActions().setAuthUser(null);
  history.navigate("/", { replace: true });
};

export const getInitialRoute = () => {
  const matchedRoutes = [];
  routes.forEach((route) => {
    if (checkPermission(route.permissions)) {
      matchedRoutes.push(route.route);
    }
  });
  return matchedRoutes[0] || "/";
};

export const onEnter = (e, fn) => {
  if (e.key === "Enter") {
    fn();
  }
};
